import {AfterViewChecked, Component, OnInit} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import {TenantService} from './shared/services/tenant/tenant.service';
import {PakTenantService} from './shared/services/pak/pak-tenant.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewChecked {
  title = 'angular-styles-akcent';
  private correlationId!: string | null;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private pakTenantService: PakTenantService,
    public tenantService: TenantService) {
      this.addAllIconsToRegistry();
  }
  private addAllIconsToRegistry(): void {
    this.addIconToIconRegistry('pzu-logo', 'assets/images/pzu_logo.svg');
    this.addIconToIconRegistry('kalendarz', 'assets/images/calendar.svg');
  }

  private addIconToIconRegistry(name: string, url: string): void {
    this.matIconRegistry.addSvgIcon(
      name, this.domSanitizer.bypassSecurityTrustResourceUrl(url)
    );
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.correlationId = params.get('correlationId')
    })
  }

  // Wysłanie eventu po aktualizacji widoku i selektora app-root powiązane
  // z wymaganą informacją dla PAK dotyczacą zmiany rozmiaru okna samoobsługi
  ngAfterViewChecked(): void {
    this.pakTenantService.emitViewChangedEvent();
  }
}
